import React from 'react'
import cn from 'classnames'

import Quotes from 'app/components/SVGS/Quotes'
import WistiaVideo from 'app/domains/common/WistiaVideo'

import './styles.scss'

const baseClass = 'quote-with-image'

const Quote = ({ proQuote, proQuoteAuthor, image, videoId, videoThumbnail, className }) => (
  <div
    className={cn(baseClass, className, {
      [`${baseClass}--video`]: videoId,
    })}
  >
    <div className={`${baseClass}__info`}>
      <div className={`${baseClass}__icon`}>
        <Quotes />
      </div>
      <div className={`${baseClass}__text`}>{proQuote}</div>
      <div className={`${baseClass}__author`}>{` - ${proQuoteAuthor}`}</div>
    </div>
    {videoId ? (
      <div className={`${baseClass}__video`}>
        <WistiaVideo videoId={videoId} videoThumbnail={videoThumbnail} height={'auto'} width={'100%'} />
      </div>
    ) : (
      <img src={image} className={`${baseClass}__image`} />
    )}
  </div>
)

export default Quote
